import React from 'react';

import Default from './Default';
import Tabs from './Tabs';

export default (props) => (
    <React.Fragment>
        {window.base.main_stage.layout === 'default' && (
            <Default
                {...props}
            />
        )}
        {window.base.main_stage.layout === 'tabs' && (
            <Tabs
                {...props}
            />
        )}
    </React.Fragment>
);
